__turbopack_context__.v({
  "button": "commonStyles-module__1YkrgW__button",
  "buttonNoBorder": "commonStyles-module__1YkrgW__buttonNoBorder",
  "buttonPrimary": "commonStyles-module__1YkrgW__buttonPrimary",
  "container": "commonStyles-module__1YkrgW__container",
  "field": "commonStyles-module__1YkrgW__field",
  "fieldPhone": "commonStyles-module__1YkrgW__fieldPhone",
  "iframe": "commonStyles-module__1YkrgW__iframe",
  "main": "commonStyles-module__1YkrgW__main",
  "rowForm": "commonStyles-module__1YkrgW__rowForm",
  "select": "commonStyles-module__1YkrgW__select",
  "submitBtn": "commonStyles-module__1YkrgW__submitBtn",
});
